export default __webpack_public_path__ + "static/media/Operação (Real Size).d93275ac.svg";